import { Badge } from "reactstrap";
import { DATE_FORMAT_VIEW } from "@src/utility/constants";
import LoadingButton from "@components/ui-components/loading-button";
import LongNameFormatter from "@components/formatters/long-name-formatter";
import useDateHandler from "@hooks/use-date-handler";
import { getStatusBadge } from "@src/utility/helpers/utils";

export const decoColumns = ({ handleRowActions }) => {
    const { dateFormatter } = useDateHandler();

    return [
        {
            name    : "Label",
            selector: (row) => row.label,
            width   : "300px",
            cell    : (row) => (
                <LongNameFormatter
                    content={row.label}
                    className="fw-bold"
                    id={`label-${row._id}`}
                    max={30}/>
            )
        },
        {
            name    : "Type",
            selector: (row) => row.type,
            width   : "150px",
            cell    : (row) => {
                const badge = getStatusBadge(row.type);
                return <Badge>{badge.title}</Badge>;
            }
        },
        {
            name    : "Required",
            selector: (row) => row.required,
            width   : "120px",
            cell    : (row) => {
                const badge = getStatusBadge(row.required ? "true" : "false");
                return <Badge color={badge.color}>{badge.title}</Badge>;
            }
        },
        {
            name    : "Order",
            selector: (row) => row.order,
            width   : "100px",
            cell    : (row) => <span>{row.order || "-"}</span>
        },
        {
            name    : "Status",
            selector: (row) => row.status,
            width   : "120px",
            cell    : (row) => {
                const badge = getStatusBadge(row.status);
                return <Badge color={badge.color}>{badge.title}</Badge>;
            }
        },
        {
            name    : "Created On",
            selector: (row) => row.createdAt,
            width   : "250px",
            cell    : (row) => (
                <span>
                    <i className="mdi mdi-calendar me-1 font-medium-2" />
                    {dateFormatter({
                        date    : row?.createdAt,
                        formatAs: DATE_FORMAT_VIEW
                    })}
                </span>
            )
        },
        {
            name : "Actions",
            width: "150px",
            cell : (row) => (
                <>
                    <LoadingButton
                        className="me-1"
                        outline
                        subject="custom-fields"
                        color="info"
                        action="edit"
                        id={`${row._id}-edit-button`}
                        testId={`${row._id}-edit-button`}
                        icon="pencil"
                        onClick={() => handleRowActions(row, "edit")}/>
                    <LoadingButton
                        className="text-danger"
                        outline
                        subject="custom-fields"
                        color="danger"
                        action="delete"
                        id={`${row._id}-delete-button`}
                        testId={`${row._id}-delete-button`}
                        icon="delete"
                        onClick={() => handleRowActions(row, "delete")}/>
                </>
            )
        }
    ];
};
